<template>
  <div class="p-0 col-12 animated fadeIn">
    <div class="card">
      <div class="card-body p-0">
        <kendo-datasource ref="partnersds"
            :transport-read="getPartner"
            :batch='true'
            :page-size='limit'
            :page="page"
            :schema="getSchema()"
            :server-paging='true'
            :server-sorting='true'
            :server-filtering='true'>
        </kendo-datasource>
        <kendo-grid ref="gridpartner" :data-source-ref="'partnersds'"
            :filterable='true'
            :pageable="{ pageSizes: [10, 15, 25, 50], buttonCount: 3, input: true }"
            :sortable='false'
            :resizable='true'
            detail-template="#= detail(created_at, name, phone, email, address, addresses, city, cities, notes) #">
          <kendo-grid-column field="name" title="Partner Name" width="175px" :filterable="filters.str"></kendo-grid-column>
          <kendo-grid-column field="phone" title="Phone" width="150px" :filterable="false" :min-screen-width="mdThreshold"></kendo-grid-column>
          <kendo-grid-column field="email" title="E-Mail" width="250px" :min-screen-width="mdThreshold" :filterable="false"></kendo-grid-column>
          <kendo-grid-column field="city" title="City" template="#= city_template(city, cities) #" width="200px" :filterable="false" :min-screen-width="mdThreshold"></kendo-grid-column>
          <kendo-grid-column field="address" title="Address" :filterable="false" :min-screen-width="mdThreshold"></kendo-grid-column>
        </kendo-grid>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      button: {
        name: 'Add Partner',
        icon: 'fa fa-users',
        url: '/customer/partners/add'
      },
      limit: 25,
      page: 1,
      mdThreshold: 900,
      filters: {
        str: {
          extra: false,
          operators: {
            string: { contains: 'contains', eq: 'exact' }
          }
        }
      }
    }
  },
  created () {
    this.$parent.button = this.button
  },
  methods: {
    getSchema () {
      // var vm = this
      return {
        data: 'results',
        total: 'count',
        parse: function (response) {
          for (var i = 0; i < response.results.length; i++) {
            response.results[i].address_template = function (address, addresses) {
              return addresses !== null && addresses !== 'null' ? addresses['address_components'][0]['short_name'] : address
            }
            response.results[i].city_template = function (city, cities) {
              return cities !== null && cities !== 'null' ? cities['address_components'][0]['short_name'] : city
            }
            response.results[i].detail = function (created, name, phone, email, address, addresses, city, cities, notes) {
              var template = '<div class="row m-0 animated fade-in">'
              template += '<div class="col-12 p-0"><strong class="text-uppercase">' + name + '</strong></div>'
              template += '<div class="col-12">'
              template += '<div class="row">'
              template += '<div class="col-6 col-md-4 p-0">Signed Date</div>'
              template += '<div class="col-6 col-md-8 p-0"><strong>' + moment(created).format('dddd, DD MMMM YYYYY') + '</strong></div>'
              template += '<div class="col-6 col-md-4 p-0">Phone Number</div>'
              template += '<div class="col-6 col-md-8 p-0"><strong>' + phone + '</strong></div>'
              template += '<div class="col-6 col-md-4 p-0">Email</div>'
              template += '<div class="col-6 col-md-8 p-0"><strong>' + email + '</strong></div>'
              template += '<div class="col-6 col-md-4 p-0">Address</div>'
              if (addresses != null && 'formatted_address' in addresses) {
                address = addresses['formatted_address']
              }
              template += '<div class="col-6 col-md-8 p-0"><strong>' + address + '</strong></div>'
              template += '<div class="col-6 col-md-4 p-0">City</div>'
              if (cities != null && 'formatted_address' in cities) {
                city = cities['formatted_address']
              }
              template += '<div class="col-6 col-md-8 p-0"><strong>' + city + '</strong></div>'
              template += '<div class="col-6 col-md-4 p-0">Notes</div>'
              var note = notes !== null && notes !== 'null' ? notes : '-'
              template += '<div class="col-6 col-md-8 p-0"><strong>' + note + '</strong></div>'
              template += '</div>'
              template += '</div>'
              template += '</div>'
              return template
            }
          }
          return response
        }
      }
    },
    getPartner (event) {
      var vm = this
      var limit = event.data.take
      var offset = event.data.skip
      var url = 'api/user/partner/?limit=' + limit + '&offset=' + offset
      // process filter
      console.log(event.data.filter)
      if (event.data.filter) {
        for (var i = 0; i < event.data.filter.filters.length; i++) {
          var filter = event.data.filter.filters[i]
          url += '&' + filter['field'] + '=' + encodeURIComponent(filter['value'] + ';' + filter['operator'])
        }
      }
      vm.axios.get(url)
        .then(
          (response) => {
            console.log(response)
            event.success(response.data)
          }
        )
        .catch(
          (error) => {
            console.log(error.response)
          }
        )
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/customer/partners/Partners.vue